export default "__VITE_ASSET__DpGwZusd__"